<template>
  <button type="submit" class="btn search">{{ name }}</button>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: ''
    }
  }
}
</script>
